import {TFunction} from 'i18next'
import {map} from 'lodash'
import queryString from 'query-string'
import {generatePath} from 'react-router'

import {appUrl, hproduce, HPRODUCE_TASKS} from '../hproduce/config'
import {TASKS_ASSIGNED_TO_ME_PARAM_KEY} from '../hproduce/consts'

export const getHProduceMyTasksUrl = () => {
  const stageSpecificHost = appUrl(hproduce.url)
  const path = generatePath(HPRODUCE_TASKS)
  const search = queryString.stringify({[TASKS_ASSIGNED_TO_ME_PARAM_KEY]: true})

  return `${stageSpecificHost}${path}?${search}`
}

export const getAssigneesValue = (assignees: {id: string; name: string}[], t: TFunction) => {
  if (!assignees || assignees.length < 1) return null
  if (assignees.length === 1) {
    return assignees[0]['name']
  }
  const last = assignees.pop()
  return map(assignees, 'name').join(', ') + ` ${t('and')} ` + last?.['name']
}
